module.exports = __webpack_public_path__ + "img/down-hn2.f7ab7fe1.jpg";